/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerApplicationStatus } from './';
import {
    FreelancerApplicationStatusFromJSON,
    FreelancerApplicationStatusFromJSONTyped,
    FreelancerApplicationStatusToJSON,
} from './';
import type { FreelancerDetailsResource } from './';
import {
    FreelancerDetailsResourceFromJSON,
    FreelancerDetailsResourceFromJSONTyped,
    FreelancerDetailsResourceToJSON,
} from './';
import type { RepatriationOpportunityGroupSummaryResource } from './';
import {
    RepatriationOpportunityGroupSummaryResourceFromJSON,
    RepatriationOpportunityGroupSummaryResourceFromJSONTyped,
    RepatriationOpportunityGroupSummaryResourceToJSON,
} from './';
import type { RepatriationOpportunityState } from './';
import {
    RepatriationOpportunityStateFromJSON,
    RepatriationOpportunityStateFromJSONTyped,
    RepatriationOpportunityStateToJSON,
} from './';

/**
 * 
 * @export
 * @interface RepatriationOpportunityTestFixturesResource
 */
export interface RepatriationOpportunityTestFixturesResource {
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityTestFixturesResource
     */
    id: string;
    /**
     * 
     * @type {RepatriationOpportunityGroupSummaryResource}
     * @memberof RepatriationOpportunityTestFixturesResource
     */
    group: RepatriationOpportunityGroupSummaryResource;
    /**
     * 
     * @type {FreelancerDetailsResource}
     * @memberof RepatriationOpportunityTestFixturesResource
     */
    freelancer: FreelancerDetailsResource;
    /**
     * 
     * @type {FreelancerApplicationStatus}
     * @memberof RepatriationOpportunityTestFixturesResource
     */
    freelancerApplicationStatus: FreelancerApplicationStatus;
    /**
     * 
     * @type {RepatriationOpportunityState}
     * @memberof RepatriationOpportunityTestFixturesResource
     */
    currentState: RepatriationOpportunityState;
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityTestFixturesResource
     */
    newFreelancerSignupLink?: string;
}

/**
 * Check if a given object implements the RepatriationOpportunityTestFixturesResource interface.
 */
export function instanceOfRepatriationOpportunityTestFixturesResource(value: object): value is RepatriationOpportunityTestFixturesResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('group' in value) || value['group'] === undefined) return false;
    if (!('freelancer' in value) || value['freelancer'] === undefined) return false;
    if (!('freelancerApplicationStatus' in value) || value['freelancerApplicationStatus'] === undefined) return false;
    if (!('currentState' in value) || value['currentState'] === undefined) return false;
    return true;
}

export function RepatriationOpportunityTestFixturesResourceFromJSON(json: any): RepatriationOpportunityTestFixturesResource {
    return RepatriationOpportunityTestFixturesResourceFromJSONTyped(json, false);
}

export function RepatriationOpportunityTestFixturesResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepatriationOpportunityTestFixturesResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'group': RepatriationOpportunityGroupSummaryResourceFromJSON(json['group']),
        'freelancer': FreelancerDetailsResourceFromJSON(json['freelancer']),
        'freelancerApplicationStatus': FreelancerApplicationStatusFromJSON(json['freelancerApplicationStatus']),
        'currentState': RepatriationOpportunityStateFromJSON(json['currentState']),
        'newFreelancerSignupLink': json['newFreelancerSignupLink'] == null ? undefined : json['newFreelancerSignupLink'],
    };
}

export function RepatriationOpportunityTestFixturesResourceToJSON(value?: RepatriationOpportunityTestFixturesResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'group': RepatriationOpportunityGroupSummaryResourceToJSON(value['group']),
        'freelancer': FreelancerDetailsResourceToJSON(value['freelancer']),
        'freelancerApplicationStatus': FreelancerApplicationStatusToJSON(value['freelancerApplicationStatus']),
        'currentState': RepatriationOpportunityStateToJSON(value['currentState']),
        'newFreelancerSignupLink': value['newFreelancerSignupLink'],
    };
}

